"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomWall = void 0;
const logger_1 = require("../../util/logger");
const repeating_task_1 = require("../../util/repeating_task");
const wall_1 = require("./wall");
const wall_item_builder_1 = require("./wall_item_builder");
class RoomWall extends wall_1.Wall {
    constructor(config) {
        super(config);
        this.isRoomStatusConnected = false;
        // In case of app refresh, update item instead of throwing error if it already exists on wall
        this.addUserItem = this.addOrUpdateItemFromBuilder('buildUserWallItem');
        this.addCapabilities = this.addOrUpdateItemFromBuilder('buildCapabilities');
        this.addStreemshotRequest = this.addItemFromBuilder('buildStreemshotRequestItem');
        this.addStreemshotResponse = this.addItemFromBuilder('buildStreemshotResponseItem');
        this.addStreemshotRevision = this.addItemFromBuilder('buildStreemshotRevisionItem');
        this.addGeolocationRequest = this.addItemFromBuilder('buildGeolocationRequestWallItem');
        this.addGeolocationResponse = this.addItemFromBuilder('buildGeolocationResponseItem');
        this.addRoomItem = this.addItemFromBuilder('buildRoomWallItem');
        this.addCameraSubjectRequest = this.addItemFromBuilder('buildCameraSubjectRequestWallItem');
        this.addCameraSubjectResponse = this.addItemFromBuilder('buildCameraSubjectResponseWallItem');
        this.createDetection = this.addItemFromBuilder('buildCreateDetectionWallItem');
        this.updateDetection = this.addItemFromBuilder('buildUpdateDetectionWallItem');
        this.hideDetection = this.addItemFromBuilder('buildHideDetectionWallItem');
        this.addBookmark = this.addOrUpdateItemFromBuilder('buildBookmarkWallItem');
        this.addRoomOutcomeReport = this.addOrUpdateItemFromBuilder('buildRoomOutcomeReportWallItem');
        this.addFavorite = this.addOrUpdateItemFromBuilder('buildFavoriteWallItem');
        logger_1.logger.info('Creating RoomWall...');
        this.builder = new wall_item_builder_1.WallItemBuilder(this.config.localDeviceId, this.config.localUserId);
        if (config.alive) {
            this.heartBeatTask = new repeating_task_1.RepeatingTask({
                taskName: RoomWall.HEART_BEAT_TASK_NAME,
                intervalMs: RoomWall.HEART_BEAT_INTERVAL_MS,
                errorThreshold: RoomWall.HEART_BEAT_ERROR_THRESHOLD,
                task: () => {
                    var _a;
                    const connectionState = this.wallSyncClient.wallSyncConnectionState;
                    if (this.tokenExpired === true) {
                        logger_1.logger.warn(`RoomWall not sending heartbeat due to expired SyncClient token`);
                    }
                    else if (connectionState != 'connected') {
                        logger_1.logger.warn(`RoomWall skipping the sending of heartbeat because SyncClient is not in 'connected' state; current connectionState=${connectionState}`);
                    }
                    else if (this.isRoomStatusConnected) {
                        // hearbeat shouldn't be updated if there's no connection to the room
                        const heartbeatWallItem = this.builder.buildHeartbeatWallItem();
                        logger_1.logger.debug(`RoomWall Sending Wall Heartbeat... wallItemId=${heartbeatWallItem.id} count=${(_a = heartbeatWallItem.heartbeat) === null || _a === void 0 ? void 0 : _a.count}`);
                        this.addOrUpdate(heartbeatWallItem);
                    }
                },
                onError: err => logger_1.logger.error(`taskName=${RoomWall.HEART_BEAT_TASK_NAME} roomId=${config.roomId}}participantId=${config.localUserId} encountered error=${err}`),
            });
        }
    }
    connect() {
        const _super = Object.create(null, {
            connect: { get: () => super.connect }
        });
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            logger_1.logger.info(`RoomWall connecting...`);
            yield _super.connect.call(this);
            this.connectedSubscription = this.connected.subscribe(isConnected => {
                this.isRoomStatusConnected = isConnected;
            });
            logger_1.logger.info('starting RoomWall heartbeat task');
            yield ((_a = this.heartBeatTask) === null || _a === void 0 ? void 0 : _a.start());
        });
    }
    disconnect() {
        const _super = Object.create(null, {
            disconnect: { get: () => super.disconnect }
        });
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            logger_1.logger.info('stopping RoomWall heartbeat task');
            (_a = this.heartBeatTask) === null || _a === void 0 ? void 0 : _a.stop();
            logger_1.logger.info(`RoomWall disconnecting...`);
            yield _super.disconnect.call(this);
            (_b = this.connectedSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
            this.isRoomStatusConnected = false;
        });
    }
    addItemFromBuilder(buildMethod) {
        return (...args) => {
            // @ts-ignore This correctly spreads arguments
            const wallItem = this.builder[buildMethod](...args);
            this.add(wallItem);
            return wallItem.id;
        };
    }
    addOrUpdateItemFromBuilder(buildMethod) {
        return (...args) => {
            // @ts-ignore This correctly spreads arguments
            const wallItem = this.builder[buildMethod](...args);
            this.addOrUpdate(wallItem);
            return wallItem.id;
        };
    }
}
exports.RoomWall = RoomWall;
RoomWall.HEART_BEAT_TASK_NAME = 'RoomWall_HeartbeatTask';
RoomWall.HEART_BEAT_INTERVAL_MS = 10000; // 10 seconds
RoomWall.HEART_BEAT_ERROR_THRESHOLD = 30;
//# sourceMappingURL=room_wall.js.map